<template>
  <div>
    <div id="stock-quotes" class="display-flex" v-bind:class="{'translate-left': translateX, 'translate-down': translateY}">
      <section>
        <h1>{{title}}</h1>
        <div id='stocks-container' class="display-flex">
          <form action="">
            <label for="input-ticker">Select stock ticker: </label>
            <input id="input-ticker" ref="input-ticker-ref" name="input-ticker" list="tickers-list" v-on:keydown.enter.prevent="submitTicker" type="text" placeholder="ticker..." pattern="[A-Z]+" value="" autocomplete="off" required />
            <datalist id="tickers-list">
              <!-- <option v-for="ticks in tickersList"
              v-bind:key="ticks.id" v-bind:value="ticks.text">
              </option> -->
              <option v-for="(ticks, index) of tickersList1"
              v-bind:key="index" v-bind:value="ticks">
              </option>
            </datalist>
            <button v-on:click="submitTicker" id="add-ticker" type="button">add</button>
          </form>
          <table>
            <caption>A list of stock tickers, prices &amp; positions</caption>
            <thead>
              <tr>
                <th>ticker</th><th>close</th><th>position</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="stocks in stocksList1" v-bind:key="stocks.id" v-html="stocks.text">
              </tr>
            </tbody>
            <tfoot>
              <tr>
                <td></td>
                <td>
                  <div>Total USD:</div>
                </td>
                <td>
                  <div>{{totalUSD}}</div>
                </td>
              </tr>
              <tr>
                <td></td>
                <td>
                  <div>Total CAD:</div>
                </td>
                <td>
                  <div>{{totalCAD}}</div>
                </td>
              </tr>
              <tr>
                <td colspan="3">
                  <div style="text-align:right;width:100%;font-size:0.8em;">{{totalCADText}}</div>
                </td>
              </tr>
            </tfoot>
          </table>
        </div>
      </section>
    </div>
    <!-- stocks button -->
    <svg id="stock-quotes-btn-svg-used" viewBox="1 1 23 23" width="38" height="38" v-on:click="openStockQuotes">
      <use xlink:href="#use1"></use>
    </svg>

    <svg id="stock-quotes-btn-svg" class="display-none">
      <defs>
        <g id="use1">
          <path id="stock-quotes-btn-svg-path1"
            d="M6,16.5L3,19.44V11H6M11,14.66L9.43,13.32L8,14.64V7H11M16,13L13,16V3H16M18.81,12.81L17,11H22V16L20.21,14.21L13,21.36L9.53,18.34L5.75,22H3L9.47,15.66L13,18.64" />
        </g>
      </defs>
    </svg>
  </div>
</template>

<script>
import * as Convert from './convert_to_dollars'
import fetchQuotes from './fetch_quotes'
import fetchUSDexchangeRate from './fetch_USD_exchange_rate'

export default {
  name: 'StockQuotes',
  props: {
    title: String
  },
  data: function() {
    return {
      stocksList1: [],
      stockIdNum: 101, //changed on login in to-do_firebase_RD
      store: [],
      tickersList: [
        {id: 0, text: 'ACB.TO'},
        {id: 1, text: 'AUSA.CN'},
        {id: 2, text: 'BB.TO'},
        {id: 3, text: 'BTC-USD'},
        {id: 4, text: 'BKE'},
        {id: 5, text: 'GGN'},
        {id: 6, text: 'HCC'},
        {id: 7, text: 'MEDFF'},
        {id: 8, text: 'MLI'},
        {id: 9, text: 'MMJ.CN'},
        {id: 10, text: 'SNN.CN'},
        {id: 11, text: 'VIVO.V'},
        {id: 12, text: 'WERN'},
        {id: 13, text: 'XRX'},
        {id: 14, text: '_____'},
        {id: 15, text: 'AAPL'},
        {id: 16, text: 'AMZN'},
        {id: 17, text: 'FB'},
        {id: 18, text: 'GOOG'},
        {id: 19, text: 'NFLX'},
        {id: 20, text: 'TWTR'},
        {id: 21, text: 'WORK'}
      ],
      tickersList1: [
        'ACB.TO',
        'AUSA.CN',
        'BB.TO',
        'BTC-USD',
        'BKE',
        'GGN',
        'HCC',
        'MEDFF',
        'MLI',
        'MMJ.CN',
        'SNN.CN',
        'VIVO.V',
        'WERN',
        'XRX',
        '_____',
        'AAPL',
        'AMZN',
        'FB',
        'GOOG',
        'NFLX',
        'TWTR',
        'WORK'
      ],
      totalCAD: '$ 0.00',
      totalCADText: '',
      translateX: true,
      translateY: false
    }
  },
  computed: {
    listLength() {
      let itemsCount = this.stocksList1.length;
      return itemsCount;
    },
    positionsTotal() {
      if (this.listLength) {
        let total = this.stocksList1.reduce(function(acc, cur) {
          let pos = Number(cur.position);
          return acc + pos;
        }, 0);
        return total
      } else return 0;
    },
    totalUSD() {
      let total = this.positionsTotal;
      let updateTotalCAD = this.updateTotalCAD;
      let updateTotalCAD_fail = this.updateTotalCAD_fail;
      fetchUSDexchangeRate()
      .then(function(value) {
        let canadianVal = total * value;
        updateTotalCAD(canadianVal) 
      })
      .catch(function(error) {
        // eslint-disable-next-line
        console.log('Error:', error)
        updateTotalCAD_fail() 
      })
      return Convert.convertToDollars(total)
    }
  },
  methods: {
    openStockQuotes() {
      this.translateY = !this.translateY;
      this.translateX = !this.translateX;
    },
    // Step 1 (called by submitTicker):
    fetchQuotesAndAddToList({idNum, tickers, units}) {
      let stocksList = this.stocksList1;
      // eslint-disable-next-line
      console.log(stocksList);
      let outer = this;
      // first argument accepts an array:
      fetchQuotes({tickers: tickers, units: units, idNum: idNum})
      .then(function(value) {
        outer.addTickerQuoteToList({quote: value, result: 'yes', idNum: idNum, stocksList: stocksList})
      })
      .catch(function(error) {
        // eslint-disable-next-line
        console.log('Error:', error)
        outer.addTickerQuoteToList({quote: error, result: 'no', idNum: idNum, stocksList: stocksList})
      })
    },
    // Step 2 (called by step 1, or by fetchTickersFromStore):
    addTickerQuoteToList({quote, result, idNum, stocksList}) {
      // eslint-disable-next-line
      console.log(quote);
      let newText;
      let ticker = quote[0];
      let price = quote[1];
      let position = quote[2];
      let id = idNum || quote[3];
      let htmlString1 = `
        <td>${ticker}</td>
        <td>${price}</td>
        <td>${position}</td>
      `;
      let htmlString2 = `
        <td colspan='3' style='text-align:center;'>could not retrieve quotes!</td>
      `;
      result === "yes" ? newText = `${htmlString1}`:   newText = `${htmlString2}`;
      let newObj = {
        id: id,
        text: newText,
        position: Convert.convertFromDollars(position)
      };
      stocksList.push(newObj);
      // eslint-disable-next-line
      console.log('newObj.id: ' + newObj.id);
      // eslint-disable-next-line
      console.log('newObj.text: ' + newObj.text);
    },
    submitTicker() {
      let tickerInput = this.$refs['input-ticker-ref'];
      let val = tickerInput.value.toUpperCase();
      tickerInput.value = '';
      let end = val.length + 1;
      let splitIndex;
      if ( val.includes(' ') ) {
        splitIndex = val.indexOf(' ');
      } else splitIndex = end;
      let ticker = val.substring(0, splitIndex).toUpperCase();
      let units = Number(val.substring(splitIndex, end));
      let idNum = this.stockIdNum;
      this.stockIdNum++;
      let tickers = [ticker];
      // eslint-disable-next-line
      console.log(tickers);
      this.fetchQuotesAndAddToList({idNum: idNum, tickers: tickers, units: units});
      // let item = {
      //   [idNum]: {
      //     ticker: ticker,
      //     units: units
      //   }
      // }
      // this.addTickerToFirebase(item);
      // this.addStockIdNumToFirebase(this.stockIdNum);
    },
    //called by setStore
    // fetchTickersFromStore() {
    //   let stocksList = this.stocksList1;
    //   let requests = store.map(this.asyncOperation); 
    //   return Promise.all(requests)
    //   .then(function(results) {
    //     // eslint-disable-next-line
    //     console.log(results)
    //     results.forEach(function(result) {
    //       this.addTickerQuoteToList({quote: result, result: 'yes', idNum: null, stocksList: stocksList})
    //     })
    //     // return results
    //   })
    //   .catch(function(error) {
    //     // eslint-disable-next-line
    //     console.log('Error:', error)
    //     this.addTickerQuoteToList({quote: error, result: 'no', idNum: null, stocksList: stocksList})
    //     // reject(error) //unnecessary if not returning value
    //   })
    // },
    asyncOperation(x) {
      let key = Object.keys(x)[0];
      let val = Object.values(x)[0];
      let idNum = key;
      let tickers = [val.ticker];
      let units = val.units;
      return fetchQuotes({tickers: tickers, units: units, idNum: idNum})
    },
    updateTotalCAD(val) {
      this.totalCAD = Convert.convertToDollars(val);
    },
    updateTotalCAD_fail() {
      this.totalCADText = '(could not retrieve exchange rate)';
    },
    getStocksList1() {
      // eslint-disable-next-line
      console.log(this.stocksList1[0].text);
      return this.stocksList1;
    }
  },
  mounted() {
    this.$nextTick(function() {
      // eslint-disable-next-line
      console.log('hello from mounted');
    })
  }
}

</script>


<style scoped>

.display-flex {
  display: flex;
}

#stock-quotes {
  --widget-color-1: rgb(3,252,171);
}

.translate-left {
  -webkit-transform: translateX(-50%); 
     -moz-transform: translateX(-50%); 
      -ms-transform: translateX(-50%); 
       -o-transform: translateX(-50%); 
          transform: translateX(-50%);
}

.translate-down {
  -webkit-transform: translate(-50%, 500px);
     -moz-transform: translate(-50%, 500px); 
      -ms-transform: translate(-50%, 500px); 
       -o-transform: translate(-50%, 500px);             
          transform: translate(-50%, 500px);
}

#stock-quotes {
  display: flex;
  position: fixed;
  z-index: 1;
  flex-direction: column;
  align-items: center;
  /* justify-content: start; */
  width: 400px;
  min-height: 400px;
  top: -420px; /* height minus 10px */
  left: 50%;
  color: #93df93;
  background-color: black;
  border-radius: 10px; /* 0.5em; */
  border: 2px solid var(--widget-color-1);
  box-shadow: 0 4px 8px 2px rgba(0, 0, 0, 0.19), 0 6px 20px 2px rgba(0, 0, 0, 0.20);
  -webkit-transition: -webkit-transform 0.3s ease;
     -moz-transition: -moz-transform 0.3s ease;
      -ms-transition: -ms-transform 0.3s ease;
       -o-transition: -o-transform 0.3s ease;
          transition: transform 0.3s ease;
}

#stocks-container {
  flex-direction: column;
  align-items: center;
}

#stock-quotes table {
  position: relative;
  width: 300px;
  margin-top: 50px;
  border-collapse: collapse;
}

#stock-quotes table caption {
  visibility: hidden;
}

#stock-quotes thead th {
  width: 100px;
  padding-bottom: 5px;
}

#stock-quotes tbody {
  width: 100px;
  text-align: right;
  /* padding-right: 5px; */
}

#stock-quotes tfoot {
  text-align: right;
  font-weight: bold;
  border-collapse: separate;
}

#stock-quotes tfoot td {
  width: 100px;
}

#stock-quotes tfoot div {
  width: 105px;
  padding-top: 8px;
  /* padding-right: 5px; */
}

#stock-quotes-btn-svg-used {
  position: fixed;
  top: 11px;
  right: 62px;
  z-index: 1;
}

#stock-quotes-btn-svg-used:hover {
  cursor: pointer;
}

#stock-quotes-btn-svg-path1 {
  fill:#2c3e50;
}

</style>